import {
	computeShoppingListSummary,
	type GsoaShoppingListGetShoppingListresponseWithProductDetail,
} from '~/utils/shoppingList';

export interface ShoppingListSummarySection {
	variant?: 'total' | 'discount' | 'highlight'
	rows: {
		label: string
		value: number
		variant?: 'discount' | 'bold' | 'highlight'
	}[]
}

export default function useShoppingListSummary(
	items: MaybeRefOrGetter<GsoaShoppingListGetShoppingListresponseWithProductDetail[]>,
) {
	const typedItems = computed(() => toValue(items));

	const summary = computed(() => computeShoppingListSummary(typedItems.value));

	const totalPrice = computed(() => summary.value.totalPrice);
	const originalPriceSum = computed(() => summary.value.originalPriceSum);
	const savedAmount = computed(() => summary.value.savedAmount);
	const toBuyPrice = computed(() => summary.value.toBuyPrice);
	const purchasedPrice = computed(() => summary.value.purchasedPrice);
	const textNotesCount = computed(() => summary.value.textNotesCount);

	const summarySections = computed<ShoppingListSummarySection[]>(() => {
		const sections: ShoppingListSummarySection[] = [
			{
				rows: [
					{
						label: 'Za nákup celkem ušetříte:',
						variant: 'discount',
						value: -savedAmount.value,
					},
				],
			},
		];

		if (typedItems.value.length > 0) {
			sections.push({
				rows: [
					{
						label: 'Položky k nákupu',
						variant: 'highlight',
						value: toBuyPrice.value,
					},
					{
						label: 'Nakoupené položky',
						value: purchasedPrice.value,
					},
				],
			});
		}

		sections.push({
			variant: 'total',
			rows: [
				{
					label: 'Předběžná cena za nákup',
					value: totalPrice.value,
				},
			],
		});

		return sections;
	});

	return {
		totalPrice,
		originalPriceSum,
		savedAmount,
		toBuyPrice,
		purchasedPrice,
		textNotesCount,
		summarySections,
	};
}
